import dayjs from "dayjs";

export const EMPTY_FIELD_PLACEHOLDER = "—";

export const TABLE_EMPTY_PLACEHOLDER = "—";

export const formatKES = (amount) =>
  amount == null
    ? EMPTY_FIELD_PLACEHOLDER
    : `KES ${Number(amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function roundToTwoDecimals(value) {
  return Math.round(value * 100) / 100;
}

export function exceedsBalance(amount, balance) {
  return roundToTwoDecimals(Number(amount)) > roundToTwoDecimals(balance);
}

export const getDisplayValue = (value, fallback = TABLE_EMPTY_PLACEHOLDER) =>
  value === null || value === undefined || value === "" ? fallback : value;

export const formatDateTimeToLocale = (date) =>
  date ? dayjs(date).format("DD MMM YYYY, HH:mm") : EMPTY_FIELD_PLACEHOLDER;

export function getInitials(name) {
  if (!name?.trim()) return null;
  return name
    .trim()
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");
}
